import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

const useRole = () => {
  const { userData } = useAuth();

  return useMemo(() => {
    const role = userData?.role || '';
    const isAdmin = role === 'hq';
    const isPartner = role === 'partner';
    const isGeneral = role === 'general';

    return {
      role,
      isAdmin,
      isPartner,
      isGeneral,
    };
  }, [userData?.role]);
};

export default useRole;
